import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import ro from "./ro.json";

const STORAGE_KEY = "lf_lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ro: { translation: ro },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ro"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

export const SUPPORTED_LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "ro", label: "Română", short: "RO" },
];

export default i18n;
